/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import styles from '../../assessmentPage/Questionnaire/GeneralInfo.module.scss';
import cn from 'classnames';

export interface Data {
    firstname: string;
    middlename: string;
    lastname: string;
    email: string;
    phone_number: string;
    password: string;
    repeatPassword: string;
    role: string;
}

export const initData: Data = {
    firstname: '',
    middlename: '',
    lastname: '',
    email: '',
    phone_number: '',
    role: '',
    password: '',
    repeatPassword: '',
};
export default function License() {
    const tableName = 'User';

    const [data, setData] = useState<any>();
    const loadData = (data: Data) => {
        data = { ...data, password: '', repeatPassword: '' };
        setData(data);
    };

    useEffect(() => {
        api.tableInput.newFetchCandidateInput(loadData, tableName);
    }, []);

    return (
        <>
            <div>
                <h4 className={styles.title}>Consultant</h4>
                <div className={`grid grid-cols-2 gap-x-5 ${cn(styles.box, styles.fullWidth)}`}>
                    <h4>Name</h4>
                    <h4>Email</h4>
                    <p className={styles.value}>
                        {data?.firstname} {data?.middlename} {data?.lastname}
                    </p>
                    <p className={styles.value}> {data?.email}</p>
                    <h4>Phone Number</h4>
                    <h4>Languages</h4>
                    <p className={styles.value}>{data?.phone_number}</p>

                    <p className={styles.value}>
                        {' '}
                        {data?.languages.map((lang: any, index: number) => lang + ' ')}
                    </p>
                </div>
            </div>
        </>
    );
}
